import {DependencyValue, PartOfSpeechValue} from 'src/app/models/enum';
import {Phenomenon} from '../../../openapi';

export class QueryMC {
    public availableValues: DependencyValue[] | PartOfSpeechValue[] | string[];
    public phenomenon: Phenomenon;
    public selectedValues: DependencyValue[] | PartOfSpeechValue[] | string[];
    constructor(init?: Partial<QueryMC>) {
        Object.assign(this, init);
    }
}

